import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table/table";
import type { SpendBucket } from "@/types/spend";
import { useDateFormatter } from "@/hooks/useDateFormatter";
import { formatGbp, moneyDisplay } from "../money-format";
import { SpendQualityLabel } from "./spend-quality-label";

export const SpendDataTable = ({ buckets }: { buckets: SpendBucket[] }) => {
  const { formatDate } = useDateFormatter();
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Period</TableHead>
          <TableHead className="text-right">Positive spend</TableHead>
          <TableHead className="text-right">Credits</TableHead>
          <TableHead className="text-right">Net actual</TableHead>
          <TableHead>Data quality</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {buckets.map(bucket => (
          <TableRow key={`${bucket.family_id}:${bucket.period_start}`}>
            <TableCell>
              {formatDate(bucket.period_start)} – {formatDate(bucket.period_end)}
            </TableCell>
            <TableCell className="text-right tabular-nums">{formatGbp(bucket.money.positive_gbp) ?? "—"}</TableCell>
            <TableCell className="text-right tabular-nums">{formatGbp(bucket.money.credits_gbp) ?? "—"}</TableCell>
            <TableCell className="text-right tabular-nums">{moneyDisplay(bucket.money)}</TableCell>
            <TableCell>
              <SpendQualityLabel money={bucket.money} coverage={bucket.coverage} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
